import * as Sentry from '@sentry/react'

import { SENTRY_SEVERITY } from '@/shared/utils/sentry'
import { cmdTypeLabel, WATCH_CMD_TYPES } from '@/shared/utils/sentry/api'

type FlowPhase = 'request' | 'response'

type FlowBreadcrumbData = {
  cmdType?: string
  errCode?: string
  errMsg?: string
}

export function addApiBreadcrumb(phase: FlowPhase, data: FlowBreadcrumbData) {
  const cmdType = data?.cmdType
  if (!cmdType || !WATCH_CMD_TYPES.has(cmdType)) return

  Sentry.addBreadcrumb({
    category: 'flow',
    message: `${cmdTypeLabel(cmdType)}[${phase}]`,
    level: phase === 'response' ? SENTRY_SEVERITY.Warning : SENTRY_SEVERITY.Info,
    data: {
      cmdType: cmdTypeLabel(cmdType),
      path: window.location.pathname,
      phase,
      ...data,
    },
  })
}
